
export default function Portfolio() {
  const projects = [
    {
      category: 'IA Personalizada',
      title: 'Neuro Agents para E-commerce',
      image: 'https://public.readdy.ai/ai/img_res/92df2be19b151959513b52fcba44e529.jpg'
    },
    {
      category: 'Site Corporativo',
      title: 'Website com IA Generativa',
      image: 'https://readdy.ai/api/search-image?query=modern%20professional%20website%20design%20on%20computer%20screen%20in%20dark%20environment%2C%20clean%20user%20interface%20with%20red%20accents%2C%20responsive%20web%20design%2C%20minimalist%20dark%20theme%20layout%2C%20contemporary%20digital%20workspace%2C%20web%20development%20concept&width=800&height=600&seq=portfolio-dark-003&orientation=landscape'
    },
    {
      category: 'Automação Inteligente',
      title: 'Sistema de Atendimento com IA',
      image: 'https://readdy.ai/api/search-image?query=intelligent%20customer%20service%20automation%20system%20with%20dark%20interface%2C%20chatbot%20AI%20technology%20visualization%2C%20modern%20digital%20communication%2C%20black%20background%20with%20cyan%20and%20purple%20accents%2C%20professional%20business%20solution%2C%20futuristic%20workflow&width=800&height=600&seq=portfolio-dark-004&orientation=landscape'
    },
    {
      category: 'Agente de IA',
      title: 'Assistente Virtual Personalizado',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20virtual%20assistant%20hologram%20interface%2C%20dark%20environment%20with%20red%20and%20cyan%20neon%20accents%2C%20modern%20artificial%20intelligence%20concept%2C%20sleek%20digital%20design%2C%20professional%20technology%20visualization%2C%20cyberpunk%20aesthetic&width=800&height=600&seq=portfolio-dark-006&orientation=landscape'
    }
  ];

  return (
    <section id="portfolio" className="py-16 sm:py-20 bg-dark-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">Projetos em Destaque</h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto">
            Conheça alguns dos projetos que desenvolvi para clientes em diferentes segmentos
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="bg-dark-800 rounded-2xl overflow-hidden border border-dark-600 hover:border-red-600/50 transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-full h-48 sm:h-52 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 sm:p-6 bg-dark-800">
                <span className="text-xs font-semibold text-red-500 uppercase tracking-wider">
                  {project.category}
                </span>
                <h3 className="text-lg sm:text-xl font-bold text-white mt-2 mb-3">{project.title}</h3>
                <div className="flex items-center justify-end">
                  <i className="ri-arrow-right-up-line text-2xl text-red-500 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
